var _rect, _path, _rect2, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-15722 -4597C-15722 -4598.1 -15721.1 -4599 -15720 -4599H14173C14174.1 -4599 14175 -4598.1 14175 -4597V23047C14175 23048.1 14174.1 23049 14173 23049H-15720C-15721.1 23049 -15722 23048.1 -15722 23047V-4597Z",
    fill: "#EFF1FF",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 414,
    height: 896,
    transform: "translate(-356 -466)",
    fill: "#F5F5F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_632)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 414,
    height: 658,
    transform: "translate(-356 -311)",
    fill: "#F5F5F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -336,
    y: -9,
    width: 374,
    height: 40,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_23_632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 7C8.79 7 7 8.79 7 11C7 13.21 8.79 15 11 15C13.21 15 15 13.21 15 11C15 8.79 13.21 7 11 7ZM19.94 10C19.48 5.83 16.17 2.52 12 2.06V0H10V2.06C5.83 2.52 2.52 5.83 2.06 10H0V12H2.06C2.52 16.17 5.83 19.48 10 19.94V22H12V19.94C16.17 19.48 19.48 16.17 19.94 12H22V10H19.94ZM11 18C7.13 18 4 14.87 4 11C4 7.13 7.13 4 11 4C14.87 4 18 7.13 18 11C18 14.87 14.87 18 11 18Z",
    fill: "#747688"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-15720 -4598H14173V-4600H-15720V-4598ZM14174 -4597V23047H14176V-4597H14174ZM14173 23048H-15720V23050H14173V23048ZM-15721 23047V-4597H-15723V23047H-15721ZM-15720 23048C-15720.6 23048 -15721 23047.6 -15721 23047H-15723C-15723 23048.7 -15721.7 23050 -15720 23050V23048ZM14174 23047C14174 23047.6 14173.6 23048 14173 23048V23050C14174.7 23050 14176 23048.7 14176 23047H14174ZM14173 -4598C14173.6 -4598 14174 -4597.55 14174 -4597H14176C14176 -4598.66 14174.7 -4600 14173 -4600V-4598ZM-15720 -4600C-15721.7 -4600 -15723 -4598.66 -15723 -4597H-15721C-15721 -4597.55 -15720.6 -4598 -15720 -4598V-4600Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 414,
    height: 658,
    fill: "white",
    transform: "translate(-356 -311)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_23_632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-1 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.65f2d1c6c88cc7f5ba85724d205534fe.svg";
export { ForwardRef as ReactComponent };